import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronDown } from "../../assets/icons";
import { DonwloadIcon1 } from "../../assets/icons";
import { useGetCustomerProfile } from "../../hooks/Query/useGetCustomerProfile";
import { useGetCustomerTransactions } from "../../hooks/Query/useGetCustomerTransactions";
import { useGetCustomerLogQueries } from "../../hooks/Query/useGetCustomerLogQueries";
import { useGetQueryTypes } from "../../hooks/Query/useGetQueryTypes";
import { useGetSubQueryTypes } from "../../hooks/Query/useGetSubQueryTypes";
import { useLogCustomerQuery } from "../../hooks/Muitation/useLogCustomerQuery";
import { useUpdateCustomerProfile } from "../../hooks/Muitation/useUpdateCustomerProfile";
import { LoadingIcon } from "../../assets/icons";
import { getCustomerTransactionsDownload } from "../../service/query/auth";

export default function HandleMemberProfile() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [showEnableModal, setShowEnableModal] = useState(false);
    const [activeTab, setActiveTab] = useState("profile");
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [transactionType, setTransactionType] = useState("0");
    const [transactionSearchEnabled, setTransactionSearchEnabled] = useState(false);
    const [ticketNumber, setTicketNumber] = useState("");
    const [queryStatus, setQueryStatus] = useState("");
    const [queryRecordSearchEnabled, setQueryRecordSearchEnabled] = useState(true);
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    const [transactionPage, setTransactionPage] = useState(1);
    const [logQueriesPage, setLogQueriesPage] = useState(1);

    const [newQueryForm, setNewQueryForm] = useState({
        customerName: "",
        membershipId: id,
        typeOfCall: "",
        communicationType: "",
        queryType: "",
        subQueryType: "",
        queryDetails: "",
        queryPriority: "",
        closureDate: "",
        closureTime: "",
        resolved: "",
        remark: "",
        file: null,
    });

    const isNewQueryFormValid = Object.entries(newQueryForm).every(([key, value]) => {
        if (key === "remark") return newQueryForm.resolved === "no" || value !== "";
        if (key === "subQueryType") return true;
        if (key === "file") return true;
        return value !== "" && value !== null && value !== undefined;
    });

    const { data: profileData, refetch: refetchProfile } = useGetCustomerProfile({ membership_id: id });
    const profile = profileData?.data?.profile;

    useEffect(() => {
        if (profile?.username) {
            setNewQueryForm(prev => ({ ...prev, customerName: profile.username }));
        }
    }, [profile?.username]);

    const isDisabled = ["inactive", "disabled", "in active"].includes(
        profile?.Membership_status?.toLowerCase()?.trim()
    );

    const { data: transactionData, isFetching: loadingTransactions } = useGetCustomerTransactions({
        membership_id: id,
        from_date: fromDate,
        to_date: toDate,
        transaction_type: transactionType,
        page: transactionPage,
        enabled: transactionSearchEnabled,
    });
    const transactions = transactionData?.data?.data ?? [];
    const transactionPagination = transactionData?.data?.pagination ?? null;
    const isLoadingTransactions = loadingTransactions;

    const { data: logQueriesData, isFetching: loadingLogQueries, refetch: refetchLogQueries } = useGetCustomerLogQueries({
        membership_id: id,
        ticket_number: ticketNumber,
        query_status: queryStatus,
        page: logQueriesPage,
        enabled: queryRecordSearchEnabled,
    });
    const logQueries = logQueriesData?.data?.data ?? [];
    const logQueriesPagination = logQueriesData?.data?.pagination ?? null;

    const { data: queryTypesData } = useGetQueryTypes();
    const queryTypes = queryTypesData?.data?.data ?? [];

    const { data: subQueryTypesData } = useGetSubQueryTypes(newQueryForm.queryType);
    const subQueryTypes = subQueryTypesData?.data?.data ?? [];

    const { mutate: logQuery, isPending: loggingQuery } = useLogCustomerQuery({
        onSuccess: () => {
            resetNewQueryForm();
            refetchLogQueries();
        },
    });

    const { mutate: updateProfile, isPending: updatingProfile } = useUpdateCustomerProfile({
        onSuccess: () => {
            setShowModal(false);
            setShowEnableModal(false);
            refetchProfile();
        },
    })

    const resetNewQueryForm = () => {
        setNewQueryForm({
            customerName: profile?.username ?? "",
            membershipId: id,
            typeOfCall: "",
            communicationType: "",
            queryType: "",
            subQueryType: "",
            queryDetails: "",
            queryPriority: "",
            closureDate: "",
            closureTime: "",
            resolved: "",
            remark: "",
            file: null,
        });
    };

    const handleDisableConfirm = () => {
        updateProfile({ membership_id: id, customer_status: 0 });
    }

    const handleEnableConfirm = () => {
        updateProfile({ membership_id: id, customer_status: 1 });
    }

    const tabs = [
        { key: "profile", label: "Profile" },
        { key: "transaction", label: "Transaction details" },
        { key: "queryRecord", label: "Member query record" },
        { key: "logQuery", label: "Log query" },
    ];

    const handleDownloadReceipt = () => {
        const { jsPDF } = require("jspdf");
        const doc = new jsPDF();

        const fields = transactionType === "1" ? [
            { label: "Reference", value: selectedReceipt.transactionRef ?? "-" },
            { label: "Date", value: selectedReceipt.Transaction_date ?? "-" },
            { label: "Membership ID", value: selectedReceipt.Membership1_id ?? "-" },
            { label: "Points redeemed", value: String(selectedReceipt.Redeem_points ?? "-") },
            { label: "Remark", value: selectedReceipt.Remarks ?? "-" },
        ] : transactionType === "2" ? [
            { label: "Date", value: selectedReceipt.Transaction_date ?? "-" },
            { label: "Membership ID", value: selectedReceipt.Membership1_id ?? "-" },
            { label: "To/From", value: selectedReceipt.Membership2_id ?? "-" },
            { label: "Transfer points", value: String(selectedReceipt.Transfer_points ?? "-") },
            { label: "Bonus points", value: String(selectedReceipt.Bonus_points ?? "-") },
        ] : [
            { label: "Bill Number", value: selectedReceipt.Bill_no ?? "-" },
            { label: "Date", value: selectedReceipt.Transaction_date ?? "-" },
            { label: "Points received", value: String(selectedReceipt.Points_received ?? "-") },
            { label: "Remark", value: selectedReceipt.Remarks ?? selectedReceipt.Description ?? "-" },
        ];

        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Receipt", 14, 20);
        doc.setLineWidth(0.5);
        doc.line(14, 25, 196, 25);
        doc.setFontSize(11);
        let y = 35;

        fields.forEach(({ label, value }) => {
            doc.setFont("helvetica", "normal");
            doc.setTextColor(90, 90, 90);
            doc.text(label, 14, y);
            doc.setFont("helvetica", "bold");
            doc.setTextColor(33, 33, 33);
            doc.text(String(value), 196, y, { align: "right" });
            doc.setDrawColor(230, 230, 230);
            doc.setLineWidth(0.2);
            doc.line(14, y + 4, 196, y + 4);
            y += 14;
        });

        doc.save(`receipt-${selectedReceipt.Transaction_date}.pdf`);
    };

    const handleDownloadTransactions = async () => {
        try {
            const response = await getCustomerTransactionsDownload({
                membership_id: id,
                from_date: fromDate,
                to_date: toDate,
                transaction_type: transactionType,
            });

            const data = response?.data?.data ?? [];
            if (!data.length) return alert("No data to download");

            // Build CSV
            const headers = Object.keys(data[0]).join(",");
            const rows = data.map((row) =>
                Object.values(row).map((val) => `"${val ?? ""}"`).join(",")
            ).join("\n");
            const csv = `${headers}\n${rows}`;

            // Download
            const blob = new Blob([csv], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `transactions-${id}-${fromDate}-${toDate}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            alert("Failed to download transactions");
        }
    };


    return (
        <div className="p-6 bg-white min-h-[80vh]">

            <div className="flex flex-col md:flex-row md:items-center justify-between mb-[36px] gap-4">
                <div className="flex flex-col gap-[11px]">
                    <button
                        onClick={() => navigate(-1)}
                        className="text-gray-500 hover:text-gray-800 transition-colors ml-[25px]"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <div className="flex items-center gap-[11px] justify-center">
                        <div className="w-[76px] h-[76px] rounded-full bg-blue-200 flex items-center justify-center text-blue-900 font-bold text-xl">
                            {profile?.username?.charAt(0)?.toUpperCase() ?? "?"}
                        </div>
                        <div className="pt-[10px]">
                            <h2 className="text-[24px] font-semibold text-black">{profile?.username ?? "..."}</h2>
                            <p className="text-[16px] text-[#0F172A]">FK-{id}</p>
                        </div>
                    </div>
                </div>

                {activeTab === "profile" && (
                    isDisabled ? (
                        <button
                            onClick={() => setShowEnableModal(true)}
                            className="border-1 border-[#003B65] text-[#003B65] px-6 py-2 rounded text-[14px] hover:bg-blue-50 w-full md:w-auto font-medium"
                        >
                            Enable member
                        </button>
                    ) : (
                        <button
                            onClick={() => setShowModal(true)}
                            className="border-1 border-[#FA2323] text-[#FA2323] px-6 py-2 rounded text-[14px] hover:bg-red-50 w-full md:w-auto font-medium"
                        >
                            Disable member
                        </button>
                    )
                )}
            </div>

            {/* Tabs */}
            <div className="flex gap-[32px] border-b border-gray-200 mb-[39px] overflow-x-auto">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`pb-3 text-sm whitespace-nowrap transition-all ${activeTab === tab.key
                            ? "border-b-2 border-blue-900 text-blue-900 font-medium"
                            : "text-gray-400 hover:text-gray-600"
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            {activeTab === "profile" && (
                <div className="space-y-[36px]">
                    {/* Basic Information */}
                    {/* <div className="p-[24px] bg-[#F8FAFC] rounded-[12px] overflow-hidden">
                        <h3 className="text-[16px] font-semibold text-[#212121]">Basic information</h3>
                        <div className="pt-[21px]">
                            {[
                                { label: "Email", value: "marvin.m@maxisoft.com" },
                                { label: "Address", value: "EY 54 Avelo, Glanduras" },
                                { label: "Mobile", value: "+01 556 8920" },
                                { label: "Birth date", value: "9/09/1999" },
                                { label: "Anniversary date", value: "9/09/1999" },
                            ].map((item) => (
                                <div key={item.label} className="flex justify-between p-[16px] bg-[#FFFFFF] rounded-[12px] mb-[8px] last:mb-0">
                                    <span className="text-[14px] text-[#5A5A5A]">{item.label}</span>
                                    <span className="text-[14px] text-[#212121] font-medium">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div> */}

                    {/* Membership Information */}
                    <div className="p-[24px] bg-[#F8FAFC] rounded-[12px] overflow-hidden">
                        <h3 className="text-[16px] font-semibold text-[#212121]">Membership information</h3>
                        <div className="pt-[21px]">
                            {[
                                { label: "Total purchase", value: `NGN ${parseFloat(profile?.Total_purchase_amount ?? 0).toLocaleString()}` },
                                { label: "Current balance", value: parseInt(profile?.Current_balance ?? 0).toLocaleString() },
                                { label: "Membership status", value: profile?.Membership_status ?? "-" },
                                // { label: "Member tier", value: profile?.Tier_id ?? "-" },
                                { label: "Total points earned", value: parseInt(profile?.Total_gained_points ?? 0).toLocaleString() },
                                { label: "Total points redeemed", value: parseInt(profile?.Total_redeem_points ?? 0).toLocaleString() },
                                { label: "Total points transferred out", value: parseInt(profile?.Total_points_transferred_out ?? 0).toLocaleString() },
                                { label: "Total points transferred in", value: parseInt(profile?.Total_points_transferred_in ?? 0).toLocaleString() },
                                { label: "Email preference", value: profile?.Email_preference ?? "-" },
                                { label: "Login status", value: profile?.Login_status ?? "-" },
                            ].map((item) => (
                                <div key={item.label} className="flex justify-between p-[16px] bg-[#FFFFFF] rounded-[12px] mb-[8px] last:mb-0">
                                    <span className="text-[14px] text-[#5A5A5A]">{item.label}</span>
                                    <span className="text-[14px] text-[#212121] font-medium">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {activeTab === "transaction" && (
                <div>
                    {/* Filters */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px] mb-[29px]">
                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[10px]">
                                From Date <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                className="w-full px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-[#919BA4] text-[12px]"
                            />
                        </div>
                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[10px]">
                                Till Date <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                className="w-full px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-[#919BA4] text-[12px]"
                            />
                        </div>
                    </div>

                    {/* Transaction type dropdown */}
                    <div className="mb-[29px]">
                        <label className="block text-[12px] font-medium text-black mb-[10px]">
                            Transaction Type
                        </label>
                        <div className="relative w-full md:w-[500px] lg:w-[700px]">
                            <select
                                value={transactionType}
                                onChange={(e) => setTransactionType(e.target.value)}
                                className="w-full appearance-none px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-[#919BA4] text-[12px]"
                            >
                                <option value="0">Transaction</option>
                                <option value="1">Redeemed</option>
                                <option value="2">Transfer</option>
                            </select>
                            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                                <ChevronDown />
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => {
                            if (!fromDate || !toDate) return;
                            setTransactionPage(1);
                            setTransactionSearchEnabled(true);
                        }}
                        disabled={!fromDate || !toDate || loadingTransactions}
                        className="bg-[#00305E] hover:bg-blue-800 text-white px-8 py-2 rounded-[5px] w-[180px] h-[38px] text-[14px] mb-[56px] flex items-center justify-center"
                    >
                        {isLoadingTransactions ? <LoadingIcon /> : "Search"}
                    </button>

                    {/* Table */}
                    {transactionSearchEnabled && (
                        <div className="rounded-md overflow-hidden">
                            {transactionSearchEnabled && transactions.length > 0 && (
                                <div className="flex justify-end mb-4">
                                    <button
                                        onClick={handleDownloadTransactions}
                                        className="border border-[#BABFC6] text-[#212121] hover:bg-blue-50 px-[12px] py-[6px] rounded-[4px] text-[14px] flex items-center gap-2 font-medium"
                                    >
                                        <DonwloadIcon1 /> Download
                                    </button>
                                </div>
                            )}
                            <div className="overflow-x-auto overflow-y-auto max-h-[400px]">
                                <table className="w-full text-sm text-left min-w-[700px]">
                                    <thead className="bg-[#F8FAFC] sticky top-0 h-[44px]">
                                        <tr>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Transaction Date ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Membership ID ↓</th>
                                            {transactionType === "1" && <>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Points Redeemed ↓</th>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Reference ↓</th>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Remarks ↓</th>
                                            </>}
                                            {transactionType === "2" && <>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Transfer Points ↓</th>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Bonus Points ↓</th>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">To/From ↓</th>
                                            </>}
                                            {transactionType === "0" && <>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Points Received ↓</th>
                                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Reference ↓</th>
                                            </>}
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Receipt ↓</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingTransactions ? (
                                            <tr>
                                                <td colSpan={6} className="text-center py-10">
                                                    <div className="flex justify-center"><LoadingIcon /></div>
                                                </td>
                                            </tr>
                                        ) : transactions.length > 0 ? (
                                            transactions.map((tx) => (
                                                <tr key={tx.Transaction_id} className="border-b hover:bg-blue-50 transition-colors">
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Transaction_date}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Membership1_id}</td>
                                                    {transactionType === "1" && <>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Redeem_points ?? "-"}</td>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.transactionRef ?? "-"}</td>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px]">{tx.Remarks ?? "-"}</td>
                                                    </>}
                                                    {transactionType === "2" && <>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Transfer_points ?? "-"}</td>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Bonus_points ?? "-"}</td>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Membership2_id ?? "-"}</td>
                                                    </>}
                                                    {transactionType === "0" && <>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.Points_received ?? "-"}</td>
                                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{tx.TransactionRefrence ?? "-"}</td>
                                                    </>}
                                                    <td className="px-[24px] py-[16px] text-[14px] whitespace-nowrap">
                                                        <button
                                                            onClick={() => { setSelectedReceipt(tx); setShowReceiptModal(true); }}
                                                            className="text-blue-700 font-medium hover:underline"
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={6} className="text-center text-gray-400 py-10">
                                                    No transactions found for the selected period.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {transactionPagination && transactionPagination.total_pages > 1 && (
                                    <div className="flex items-center justify-between mt-4 px-2">
                                        <p className="text-[12px] text-[#64748B]">
                                            Page {transactionPagination.current_page} of {transactionPagination.total_pages} — {transactionPagination.total} records
                                        </p>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => setTransactionPage(p => Math.max(1, p - 1))}
                                                disabled={transactionPagination.current_page === 1 || isLoadingTransactions}
                                                className={`px-3 py-1 rounded text-[12px] border transition-all ${transactionPagination.current_page === 1 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-[#00305E] text-[#00305E] hover:bg-blue-50"}`}
                                            >
                                                Previous
                                            </button>
                                            <button
                                                onClick={() => setTransactionPage(p => Math.min(transactionPagination.total_pages, p + 1))}
                                                disabled={transactionPagination.current_page === transactionPagination.total_pages || isLoadingTransactions}
                                                className={`px-3 py-1 rounded text-[12px] border transition-all ${transactionPagination.current_page === transactionPagination.total_pages ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-[#00305E] text-[#00305E] hover:bg-blue-50"}`}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Empty state before search */}
                    {!transactionSearchEnabled && (
                        <div className="bg-[#F5F5F5] h-[200px] flex items-center justify-center rounded-lg">
                            <p className="text-[#6D6D6D] text-[14px]">Select a date range and click Search</p>
                        </div>
                    )}
                </div>
            )}

            {activeTab === "queryRecord" && (
                <div>
                    <div className="grid grid-cols-1 md:grid-ciols-2 lg:grid-cols-3 gap-[20px] mb-[29px]">
                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[10px]">
                                Ticket Number
                            </label>
                            <input
                                type="text"
                                value={ticketNumber}
                                onChange={(e) => setTicketNumber(e.target.value)}
                                placeholder="Enter number"
                                className="w-full px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-[#919BA4] text-[12px]"
                            />
                        </div>
                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[10px]">
                                Query Status
                            </label>
                            <div className="relative">
                                <select
                                    value={queryStatus}
                                    onChange={(e) => setQueryStatus(e.target.value)}
                                    className="w-full appearance-none px-[15px] py-[9px] border border-[#CED4DF] rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-[#919BA4] text-[12px]"
                                >
                                    <option value="">All</option>
                                    <option value="Open">Open</option>
                                    <option value="Closed">Closed</option>
                                    <option value="Forward">Forward</option>
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                                    <ChevronDown />
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => {
                            setLogQueriesPage(1);
                            setQueryRecordSearchEnabled(true)
                        }}
                        disabled={loadingLogQueries}
                        className={`px-8 py-2 rounded-[5px] w-[180px] h-[38px] text-[14px] mb-[56px] flex items-center justify-center text-white transition-all ${!ticketNumber ? "bg-gray-300 cursor-not-allowed" : "bg-[#00305E] hover:bg-blue-800"
                            }`}
                    >
                        {loadingLogQueries ? <LoadingIcon /> : "Search"}
                    </button>

                    {/* Table */}
                    {queryRecordSearchEnabled && (
                        <div className="rounded-md overflow-hidden">
                            <div className="overflow-x-auto overflow-y-auto max-h-[400px]">
                                <table className="w-full text-sm text-left min-w-[900px]">
                                    <thead className="bg-[#F8FAFC] sticky top-0 h-[44px]">
                                        <tr>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Ticket ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Query Type ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Query details ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Priority ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Creation date ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Query status ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Logged by ↓</th>
                                            <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Attachment ↓</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loadingLogQueries ? (
                                            <tr>
                                                <td colSpan={7} className="text-center py-10">
                                                    <div className="flex justify-center"><LoadingIcon /></div>
                                                </td>
                                            </tr>
                                        ) : logQueries.length > 0 ? (
                                            logQueries.map((query) => (
                                                <tr key={query.Ticket} className="border-b hover:bg-blue-50 transition-colors">
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{query.Ticket}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{query.Query_type}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px]">{query.Query_details}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{query.Priority}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{query.Creation_date}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{query.Query_status}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{query.Logged_by}</td>
                                                    <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">
                                                        {query.Attachment ? (
                                                            <a
                                                                href={query.Attachment}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="text-blue-700 hover:underline"
                                                            >
                                                                View
                                                            </a>
                                                        ) : "-"}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={7} className="text-center text-gray-400 py-10">
                                                    No records found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {logQueriesPagination && logQueriesPagination.total_pages > 1 && (
                                    <div className="flex items-center justify-between mt-4 px-2">
                                        <p className="text-[12px] text-[#64748B]">
                                            Page {logQueriesPagination.current_page} of {logQueriesPagination.total_pages} — {logQueriesPagination.total} records
                                        </p>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => setLogQueriesPage(p => Math.max(1, p - 1))}
                                                disabled={logQueriesPagination.current_page === 1 || loadingLogQueries}
                                                className={`px-3 py-1 rounded text-[12px] border transition-all ${logQueriesPagination.current_page === 1 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-[#00305E] text-[#00305E] hover:bg-blue-50"}`}
                                            >
                                                Previous
                                            </button>
                                            <button
                                                onClick={() => setLogQueriesPage(p => Math.min(logQueriesPagination.total_pages, p + 1))}
                                                disabled={logQueriesPagination.current_page === logQueriesPagination.total_pages || loadingLogQueries}
                                                className={`px-3 py-1 rounded text-[12px] border transition-all ${logQueriesPagination.current_page === logQueriesPagination.total_pages ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-[#00305E] text-[#00305E] hover:bg-blue-50"}`}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Empty state */}
                    {/* {!queryRecordSearchEnabled && (
                        <div className="bg-[#F5F5F5] h-[200px] flex items-center justify-center rounded-lg">
                            <p className="text-[#6D6D6D] text-[14px]">Click Search to see records</p>
                        </div>
                    )} */}
                </div>
            )}

            {activeTab === "logQuery" && (
                <div className="max-w-[600px]">
                    <div className="space-y-4">

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">
                                Upload screenshot (optional)
                            </label>
                            <div
                                onClick={() => document.getElementById("file-upload").click()}
                                className="w-full border border-dashed border-[#CED4DF] rounded-[5px] px-[15px] py-[12px] flex items-center gap-3 cursor-pointer hover:border-blue-900 hover:bg-blue-50 transition-all"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#809DB2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M17 8L12 3L7 8" stroke="#809DB2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 3V15" stroke="#809DB2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <div>
                                    <p className="text-[12px] text-[#00305E] font-medium">
                                        {newQueryForm.file ? newQueryForm.file.name : "Click to upload screenshot"}
                                    </p>
                                    <p className="text-[11px] text-[#919BA4]">PNG, JPG, JPEG supported</p>
                                </div>
                                {newQueryForm.file && (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setNewQueryForm({ ...newQueryForm, file: null });
                                        }}
                                        className="ml-auto text-gray-400 hover:text-red-500 text-lg"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                            <input
                                id="file-upload"
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={(e) => setNewQueryForm({ ...newQueryForm, file: e.target.files[0] ?? null })}
                            />
                        </div>

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">Membership ID</label>
                            <input
                                type="text"
                                value={newQueryForm.membershipId}
                                onChange={(e) => setNewQueryForm({ ...newQueryForm, membershipId: e.target.value })}
                                className="w-full px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-900"
                            />
                        </div>

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">Type of call</label>
                            <div className="relative">
                                <select
                                    value={newQueryForm.typeOfCall}
                                    onChange={(e) => setNewQueryForm({ ...newQueryForm, typeOfCall: e.target.value })}
                                    className="w-full appearance-none px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-[#919BA4] focus:outline-none focus:ring-1 focus:ring-blue-900"
                                >
                                    <option value="">Select</option>
                                    <option value="Inbound">Inbound</option>
                                    <option value="Outbound">Outbound</option>
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500"><ChevronDown /></div>
                            </div>
                        </div>

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">Communication type</label>
                            <div className="relative">
                                <select
                                    value={newQueryForm.communicationType}
                                    onChange={(e) => setNewQueryForm({ ...newQueryForm, communicationType: e.target.value })}
                                    className="w-full appearance-none px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-[#919BA4] focus:outline-none focus:ring-1 focus:ring-blue-900"
                                >
                                    <option value="">Select</option>
                                    <option value="Email">Email</option>
                                    <option value="Voice">Voice</option>
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500"><ChevronDown /></div>
                            </div>
                        </div>

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">Query type</label>
                            <div className="relative">
                                <select
                                    value={newQueryForm.queryType}
                                    onChange={(e) => setNewQueryForm({ ...newQueryForm, queryType: e.target.value, subQueryType: "" })}
                                    className="w-full appearance-none px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-[#919BA4] focus:outline-none focus:ring-1 focus:ring-blue-900"
                                >
                                    <option value="">Select</option>
                                    {queryTypes
                                        .filter((qt) => qt.Query_type_id !== 0)
                                        .map((qt) => (
                                            <option key={qt.Query_type_id} value={qt.Query_type_id}>
                                                {qt.Query_type_name}
                                            </option>
                                        ))}
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500"><ChevronDown /></div>
                            </div>
                        </div>

                        {newQueryForm.queryType && (
                            <div>
                                <label className="block text-[12px] font-medium text-black mb-[8px]">Sub query type</label>
                                <div className="relative">
                                    <select
                                        value={newQueryForm.subQueryType}
                                        onChange={(e) => setNewQueryForm({ ...newQueryForm, subQueryType: e.target.value })}
                                        className="w-full appearance-none px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-[#919BA4] focus:outline-none focus:ring-1 focus:ring-blue-900"
                                    >
                                        <option value="">Select</option>
                                        {subQueryTypes
                                            .filter((sq) => sq.Query_id !== 0)
                                            .map((sq) => (
                                                <option key={sq.Query_id} value={sq.Query_id}>
                                                    {sq.Sub_query}
                                                </option>
                                            ))}
                                    </select>
                                    <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500"><ChevronDown /></div>
                                </div>
                            </div>
                        )}

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">Query details</label>
                            <textarea
                                rows={4}
                                value={newQueryForm.queryDetails}
                                onChange={(e) => setNewQueryForm({ ...newQueryForm, queryDetails: e.target.value })}
                                className="w-full px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] text-[12px] text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-900 resize-none"
                            />
                        </div>

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">Query priority</label>
                            <div className="relative">
                                <select
                                    value={newQueryForm.queryPriority}
                                    onChange={(e) => setNewQueryForm({ ...newQueryForm, queryPriority: e.target.value })}
                                    className="w-full appearance-none px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-[#919BA4] focus:outline-none focus:ring-1 focus:ring-blue-900"
                                >
                                    <option value="">Select</option>
                                    <option value="1">High</option>
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500"><ChevronDown /></div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-[12px] font-medium text-black mb-[8px]">Expected closure date</label>
                                <input
                                    type="date"
                                    value={newQueryForm.closureDate}
                                    onChange={(e) => setNewQueryForm({ ...newQueryForm, closureDate: e.target.value })}
                                    className="w-full px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-900"
                                />
                            </div>
                            <div>
                                <label className="block text-[12px] font-medium text-black mb-[8px]">Expected closure time</label>
                                <input
                                    type="time"
                                    value={newQueryForm.closureTime}
                                    onChange={(e) => setNewQueryForm({ ...newQueryForm, closureTime: e.target.value })}
                                    className="w-full px-[15px] border border-[#CED4DF] rounded-[5px] h-[40px] text-[12px] text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-900"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-[12px] font-medium text-black mb-[8px]">
                                Have you been able to resolve this query?
                            </label>
                            <div className="flex gap-6">
                                <label className="flex items-center gap-2 text-[12px] text-gray-700 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="resolved"
                                        value="yes"
                                        checked={newQueryForm.resolved === "yes"}
                                        onChange={(e) => setNewQueryForm({ ...newQueryForm, resolved: e.target.value })}
                                        className="accent-[#00305E]"
                                    />
                                    Yes
                                </label>
                                <label className="flex items-center gap-2 text-[12px] text-gray-700 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="resolved"
                                        value="no"
                                        checked={newQueryForm.resolved === "no"}
                                        onChange={(e) => setNewQueryForm({ ...newQueryForm, resolved: e.target.value })}
                                        className="accent-[#00305E]"
                                    />
                                    No
                                </label>
                            </div>

                            {newQueryForm.resolved === "yes" && (
                                <div className="mt-4">
                                    <label className="block text-[12px] font-medium text-black mb-[8px]">Remark</label>
                                    <textarea
                                        rows={3}
                                        value={newQueryForm.remark}
                                        onChange={(e) => setNewQueryForm({ ...newQueryForm, remark: e.target.value })}
                                        placeholder="Enter remark..."
                                        className="w-full px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] text-[12px] text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-900 resize-none"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="flex justify-end pt-4 border-t border-gray-200">
                            <button
                                disabled={!isNewQueryFormValid || loggingQuery}
                                onClick={() => {
                                    logQuery({
                                        membership_id: id,
                                        call_type: newQueryForm.typeOfCall,
                                        comm_type: newQueryForm.communicationType,
                                        query_priority: newQueryForm.queryPriority,
                                        query_type: newQueryForm.queryType,
                                        sub_query_type: newQueryForm.subQueryType,
                                        expected_closure_date: newQueryForm.closureDate,
                                        expected_closure_time: newQueryForm.closureTime,
                                        question: newQueryForm.resolved === "yes" ? 1 : 0,
                                        query_details: newQueryForm.queryDetails,
                                        remark: newQueryForm.resolved === "yes" ? newQueryForm.remark : "",
                                        file: newQueryForm.file,
                                    });
                                }}
                                className={`px-6 py-2 rounded text-[12px] text-white transition-all ${isNewQueryFormValid && !loggingQuery
                                    ? "bg-[#00305E] hover:bg-blue-800 cursor-pointer"
                                    : "bg-gray-300 cursor-not-allowed"
                                    }`}
                            >
                                {loggingQuery ? <LoadingIcon /> : "Save"}
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* Disable Modal */}
            {showModal && (
                <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex items-center justify-center z-50 px-4">
                    <div className="bg-white rounded-lg p-6 w-full max-w-[400px] shadow-xl">
                        <div className="flex justify-between items-center mb-3">
                            <h3 className="text-base font-semibold text-gray-900">Disable member</h3>
                            <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-600 text-xl">✕</button>
                        </div>
                        <p className="text-sm text-gray-500 mb-6">
                            Are you sure you would like to disable this membership ID? The customer will lose access to the loyalty program.
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={handleDisableConfirm}
                                disabled={updatingProfile}
                                className="flex-1 border-2 border-[#222222] bg-[#FA2323] hover:bg-red-600 text-[#FFFFFF] py-2 rounded text-sm font-medium flex items-center justify-center"
                            >
                                {updatingProfile ? <LoadingIcon /> : "Disable"}
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="flex-1 border-2 border-[#222222] bg-[#ffffff] text-[#000000] py-2 rounded text-sm hover:bg-gray-100"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showEnableModal && (
                <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex items-center justify-center z-50 px-4">
                    <div className="bg-white rounded-lg p-6 w-full max-w-[400px] shadow-xl">
                        <div className="flex justify-between items-center mb-3">
                            <h3 className="text-base font-semibold text-gray-900">Enable member</h3>
                            <button onClick={() => setShowEnableModal(false)} className="text-gray-400 hover:text-gray-600 text-xl">✕</button>
                        </div>
                        <p className="text-sm text-gray-500 mb-6">
                            Are you sure you would like to enable this membership ID? The customer will regain access to the loyalty program.
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={handleEnableConfirm}
                                disabled={updatingProfile}
                                className="flex-1 border-2 border-[#222222] bg-[#003B65] hover:bg-blue-900 text-white py-2 rounded text-sm font-medium flex items-center justify-center"
                            >
                                {updatingProfile ? <LoadingIcon /> : "Enable"}
                            </button>
                            <button
                                onClick={() => setShowEnableModal(false)}
                                className="flex-1 border-2 border-[#222222] bg-[#ffffff] text-[#000000] py-2 rounded text-sm hover:bg-gray-100"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Receipt Modal */}
            {showReceiptModal && selectedReceipt && (
                <div className="fixed inset-0 backdrop-blur-sm bg-white/30 flex items-center justify-center z-50">
                    <div className="p-[24px] bg-[#FFFFFF] rounded-md w-full max-w-[700px] shadow-xl max-h-[90vh] overflow-y-auto">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-[21px]">
                            <h3 className="text-[16px] font-semibold text-[#212121]">Receipt</h3>
                            <button onClick={() => setShowReceiptModal(false)} className="text-gray-400 hover:text-black text-xl">✕</button>
                        </div>

                        {/* Receipt Content */}
                        <div id="receipt-print-area">
                            {(() => {
                                const fields = transactionType === "1" ? [
                                    { label: "Reference", value: selectedReceipt.transactionRef ?? "-" },
                                    { label: "Date", value: selectedReceipt.Transaction_date ?? "-" },
                                    { label: "Membership ID", value: selectedReceipt.Membership1_id ?? "-" },
                                    { label: "Points redeemed", value: selectedReceipt.Redeem_points ?? "-" },
                                    { label: "Remark", value: selectedReceipt.Remarks ?? "-" },
                                ] : transactionType === "2" ? [
                                    { label: "Date", value: selectedReceipt.Transaction_date ?? "-" },
                                    { label: "Membership ID", value: selectedReceipt.Membership1_id ?? "-" },
                                    { label: "To/From", value: selectedReceipt.Membership2_id ?? "-" },
                                    { label: "Transfer points", value: selectedReceipt.Transfer_points ?? "-" },
                                    { label: "Bonus points", value: selectedReceipt.Bonus_points ?? "-" },
                                ] : [
                                    { label: selectedReceipt.Transaction_type === "Redemption" ? "Transaction Reference" : "Bill Number", value: selectedReceipt.Transaction_type === "Redemption" ? (selectedReceipt.TransactionRefrence ?? "-") : (selectedReceipt.Bill_no ?? "-") },
                                    { label: "Date", value: selectedReceipt.Transaction_date ?? "-" },
                                    { label: "Transaction type", value: selectedReceipt.Transaction_type ?? "-" },
                                    { label: selectedReceipt.Transaction_type === "Redemption" ? "Points used" : "Points received", value: selectedReceipt.Transaction_type === "Redemption" ? (selectedReceipt.Points_used ?? "-") : (selectedReceipt.Points_received ?? "-") },
                                    { label: "Remark", value: selectedReceipt.Remarks ?? selectedReceipt.Description ?? "-" },
                                ];

                                return fields.map((item) => (
                                    <div key={item.label} className="flex justify-between h-[52px] mb-[8px] bg-[#F9F9F9] p-[16px] rounded-[12px] last:mb-0">
                                        <span className="text-[14px] text-[#5A5A5A]">{item.label}</span>
                                        <span className="text-[14px] text-[#212121] font-medium text-right ml-4">{item.value}</span>
                                    </div>
                                ));
                            })()}
                        </div>

                        {/* Download Button */}
                        <div className="p-6 flex justify-end">
                            <button
                                onClick={handleDownloadReceipt}
                                className="border-1 border-[#BABFC6] text-[#212121] hover:bg-blue-50 px-[12px] py-[6px] rounded-[4px] text-[14px] flex items-center gap-2 font-medium"
                            >
                                <DonwloadIcon1 /> Download
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}